import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { capitalize } from '~/utils/capitalize'
import getConfig from 'next/config'

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

const isBrowser = typeof window !== 'undefined'
const APOLLO_URI = isBrowser
  ? publicRuntimeConfig.NEXT_PUBLIC_API_URL
  : serverRuntimeConfig.SECRET_INTERNAL_API_URL

const batchHttpLink = context => {
  const pageInfo = () => {
    if (isBrowser) return {}
    if (!context?.req) return {}

    const pathName = context.req.url
    const page = capitalize(pathName.split('?')[0].split('/')[1] || 'home').replace(/-/g, ' ')
    const path = encodeURIComponent(pathName)

    return { page, path }
  }
  const { page, path } = pageInfo()

  return new BatchHttpLink({
    uri: () => {
      return isBrowser
        ? `${APOLLO_URI}/graphql/public?`
        : `${APOLLO_URI}/graphql/public?page=${page}&path=${path}`
    },
    credentials: 'same-origin',
  })
}

export default batchHttpLink
